import { ApprovalHistoryTable } from "./ApprovalHistoryTable";

export default ApprovalHistoryTable;
